import { render } from "./AgencyIcon.vue?vue&type=template&id=86267d86"
import script from "./AgencyIcon.vue?vue&type=script&lang=js"
export * from "./AgencyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__